module.exports = "pegasus_template/assets/square-youtube.gif";